import { useState } from "react";
import { toast } from "sonner";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from "./ui/dialog";
import { Button } from "./ui/button";
import api, { formatApiError } from "../lib/api";

export default function DeletePaymentDialog({ payment, onClose, onDone }) {
  const [deleting, setDeleting] = useState(false);

  const deletePayment = async (event) => {
    event.preventDefault();
    setDeleting(true);
    try {
      await api.delete(`/payments/${payment.id}`);
      toast.success("Payment deleted from balances and reports");
      onDone();
      onClose();
    } catch (error) {
      toast.error(formatApiError(error));
    } finally {
      setDeleting(false);
    }
  };

  return (
    <Dialog open={Boolean(payment)} onOpenChange={(open) => !open && onClose()}>
      <DialogContent data-testid="delete-payment-dialog">
        <DialogHeader>
          <DialogTitle>Delete payment?</DialogTitle>
          <DialogDescription>
            This permanently removes the payment from balances, the timeline, reports, and its
            related payment audit entries.
          </DialogDescription>
        </DialogHeader>
        <form className="dialog-form" onSubmit={deletePayment}>
          <div className="dialog-actions">
            <Button
              type="button"
              variant="outline"
              onClick={onClose}
              data-testid="cancel-delete-payment-button"
            >
              Cancel
            </Button>
            <Button
              type="submit"
              variant="destructive"
              disabled={deleting}
              data-testid="confirm-delete-payment-button"
            >
              {deleting ? "Deleting…" : "Delete payment"}
            </Button>
          </div>
        </form>
      </DialogContent>
    </Dialog>
  );
}